import React from "react";
import NewDate from "./NewDate";
import WeatherTemperature from "./WeatherTemperature";

export default function WeatherInfo(props) {
    return (
        <div class="WeatherInfo">
        <div class="overview">
        <h1 id="city">{props.data.city}</h1>
        <ul>
          <li id="time"><NewDate date={props.data.time} /></li>
          <li id="description">{props.data.description}</li>
        </ul>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="d-flex weather-temperature">
            <img
              src={props.data.iconUrl}
              alt={props.data.description}
              id="icon"
            />
           
              <WeatherTemperature celsius={props.data.temperature} />
       
          
          </div>
        </div>
        <div class="col-6">
          <ul>
         
            <li>Humidity: <span id="humidity">{props.data.humidity}</span>%</li>
            <li>Wind: <span id="wind">{Math.round(props.data.wind)}</span> km/h</li>
          </ul>
        </div>
      </div>
      </div>
    )
}